export const STORAGE_PREFIX = 'tdi__';

export const GAME_DATA_PATH = 'https://raw.githubusercontent.com/mhollingshead/thisdatein/main/server/data.json';

export const MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
